import React from 'react';

import swedishDeathCleaningImage from '@images_responsive/home/partnerships/swedish_death_cleaning.jpg';

import { BaseCard } from './base_card';
import { SizedResponsiveImage } from './sized_responsive_image';

export const SwedishDeathCleaningCard: React.FC = () => (
  <BaseCard
    heading="Swedish Death Cleaning"
    subheading="Clutter is teaming with Amy Poehler in The Gentle Art of Swedish Death Cleaning"
    container="swedish_death_cleaning"
    media={
      <SizedResponsiveImage
        image={swedishDeathCleaningImage}
        alt="Clutter is teaming with Amy Poehler in The Gentle Art of Swedish Death Cleaning"
      />
    }
    body={
      <>
        Swedish Death Cleaning is the ultimate home makeover show, hosted by Amy
        Poehler. Each episode Clutter helps a Swedish Death Cleaner as they help
        people at a crossroads in their lives declutter their homes and say
        goodbye to unnecessary belongings through the practice of döstädning.{' '}
        <a
          href="https://variety.com/2022/tv/news/peacock-amy-poehler-gentle-art-of-swedish-death-cleaning-1235227555/"
          target="_blank"
        >
          Coming soon on Peacock
        </a>
        .
      </>
    }
  />
);
